import { Package } from 'lucide-react';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { EmptyState } from '@/components/ui/EmptyState';

interface Props {
  items?: Array<{ id: string; title: string; available_quantity: number }> | null;
}

export function InventoryAlerts({ items }: Props) {
  const list = items ?? [];
  return (
    <div className="card p-5 h-full">
      <SectionHeader
        title="Alertas de estoque"
        subtitle="Anúncios com 5 un. ou menos"
      />
      {list.length === 0 ? (
        <EmptyState
          icon={Package}
          title="Sem alertas de estoque"
          description="Nenhum anúncio ativo com estoque baixo no Mercado Livre."
        />
      ) : (
        <ul className="space-y-2 mt-2">
          {list.slice(0, 6).map((it) => (
            <li key={it.id} className="flex items-center gap-3">
              <span className={`w-7 h-7 rounded-full text-xs font-bold flex items-center justify-center shrink-0 ${
                it.available_quantity === 0 ? 'bg-negative/10 text-negative' : 'bg-warning/15 text-warning'
              }`}>
                {it.available_quantity}
              </span>
              <a
                href={`https://www.mercadolivre.com.br/anuncios/${it.id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-ink truncate flex-1 hover:underline"
                title={it.title}
              >
                {it.title}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
